import { Location } from "react-router-dom";

export const isCurrentLocation = (location: Location, href: string) =>
  href === "/" ? location.pathname === "/" : location.pathname.startsWith(href);

export const sleep = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));

export const isTruthy = <A>(a: A | undefined | null): a is A => Boolean(a);

export const asyncNoop = async () => Promise.reject(new Error("noop"));

export const downloadFileBlob = (fileBlob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(new Blob([fileBlob]));
  downloadFileFromUrl(url, filename);
  URL.revokeObjectURL(url);
};

export const downloadFileFromUrl = (url: string, filename = "") => {
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.parentNode!.removeChild(link);
};

// Replace hyphen in date to an underscore
export const hyphensToUnderscores = (date: string) => date.replace(/-/g, "_");
